module.exports = __webpack_public_path__ + "static/media/tour-cup.36ec4a1a.svg";